import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { PaymentPageHeaderBlockConfig } from '@front-platform/content-builder';
import { paymentPageHeaderBlockResolveConfig } from '@front-platform/content-builder';
import { Router } from '@angular/router';
import { Component, input, computed } from '@angular/core';

import { Paths } from '@config/paths.config';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { AnalyticsService } from '@core/services/app/analytics.service';
export interface PaymentPageHeaderBlockRuntimeConfig {}

export type PaymentPageHeaderBlockConfigInput = Partial<
  Omit<PaymentPageHeaderBlockConfig, keyof PaymentPageHeaderBlockRuntimeConfig> &
    PaymentPageHeaderBlockRuntimeConfig
>;
export type PaymentPageHeaderBlockResolvedConfig = Omit<
  PaymentPageHeaderBlockConfig,
  keyof PaymentPageHeaderBlockRuntimeConfig
> &
  Partial<PaymentPageHeaderBlockRuntimeConfig>;
export interface PaymentPageHeaderBlockContract extends ConfigComponentContract<
  PaymentPageHeaderBlockConfigInput,
  PaymentPageHeaderBlockResolvedConfig
> {}

@Component({
  selector: 'app-payment-page-header-block',
  templateUrl: './payment-page-header-block.component.html',
  standalone: false,
})
export class PaymentPageHeaderBlockComponent implements PaymentPageHeaderBlockContract {
  readonly config = input<PaymentPageHeaderBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    PaymentPageHeaderBlockConfig,
    PaymentPageHeaderBlockRuntimeConfig
  >(paymentPageHeaderBlockResolveConfig, () => ({ config: this.config() }));
  readonly backLinkUrl = computed(
    () => this.resolvedConfig()['back_link_url'] as unknown as string,
  );
  readonly textColor = computed(
    () => this.resolvedConfig()['text_color'] as unknown as IContentBuilderFieldColor,
  );
  readonly backgroundColor = computed(
    () => this.resolvedConfig()['background_color'] as unknown as IContentBuilderFieldColor,
  );

  constructor(
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
    private readonly navigationService: NavigationHistoryService,
    private readonly analyticsService: AnalyticsService,
  ) {}

  back(): void {
    const history = this.navigationService.getHistory();
    const previousState = history[history.length - 2];

    const backLinkUrl = this.backLinkUrl();
    console.log('[PaymentPageHeader] back click', {
      backLinkUrl,
      historyLength: history.length,
      previousIdentifier: previousState?.identifier,
      previousRoute: previousState?.route,
    });

    if (backLinkUrl) {
      if (!this.routerHelper.isLinkExternal(backLinkUrl)) {
        console.log('[PaymentPageHeader] navigating to internal configured backLinkUrl', {
          translatedRoute: this.routerHelper.translateRoute(backLinkUrl),
        });
        this.router.navigate([this.routerHelper.translateRoute(backLinkUrl)]);
      } else {
        console.log('[PaymentPageHeader] navigating to external configured backLinkUrl');
        window.location.href = backLinkUrl;
      }
      return;
    }

    if (previousState?.identifier === 'cart-funnel') {
      console.log('[PaymentPageHeader] fallback to cart because previous state is cart-funnel');
      this.router.navigate([this.routerHelper.translateRoute(Paths.Cart)]);
    } else {
      console.log('[PaymentPageHeader] fallback to navigationService.goBack()');
      this.navigationService.goBack();
    }
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(PaymentPageHeaderBlockComponent, {
  'keyAliases': {},
});
